var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"fontSize",attrs:{"absolute":"","color":"#1c3d50","dark":""}},[_c('div',{staticClass:"font-weight-regular"},[_vm._v(" ©2017- "+_vm._s(new Date().getFullYear())+" Global Psytech Sdn. Bhd.")])])}
var staticRenderFns = []

export { render, staticRenderFns }